import {Component, OnInit} from '@angular/core';
import { TipoAlimentosBebidas } from 'src/app/models/tipo-alimentos-bebidas'

import {CatalogosService} from '../../../services/catalogos.service';

@Component({
  selector: 'app-lista-alimentos-bebidas',
  templateUrl: './lista-alimentos-bebidas.component.html',
  styleUrls: ['./lista-alimentos-bebidas.component.css']
})
export class ListadoAlimentosYBebidas implements OnInit {

  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio'
    },
    {
      label: 'DISAM / MAG',
      routerLink: '/disam-mag'
    }
  ];

  tipos: TipoAlimentosBebidas[];
  loading = false;

  constructor(private catalogosService: CatalogosService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposAlimentosYBebidas().subscribe((tipos) => {
      this.loading = false;
      const array: any[] = [];
      tipos.map((p, key) => {
        // Seleccionando inscripcion de contratos de la funcion getTiposPoderes
        const descripcion = p.descripcion ? p.descripcion : '';
        array.push(p);
      });
      this.tipos = array;
    });
  }
}
